import styled from 'styled-components'

import { color, space, SpaceProps, spacing, typography } from '../../../themes'

export const Container = styled.div<SpaceProps>`
  ${space};
  display: flex;
  align-items: center;
`

export const Label = styled.label`
  ${typography('subhead1')}
  color: ${color('gray.01')};
`

export const RequiredBadge = styled.div`
  ${typography('subhead3')}
  color: ${color('red.01')};
  margin-left: ${spacing(1)};
`
